import React from 'react';

import Slick from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import * as cn from 'classnames';
import images from "./images";
import "./slider.scss";
class Slider extends React.Component{

    constructor(props){
        super(props);
    }
    
    render(){
        var settings = {
            dots: true,
            infinite: true,
            focusOnSelect:true,
            speed: 500,
            className:'slider variable-width',
            slidesToScroll: 1,
            
           
            
        };
       
        return(
            <div >
                <Slick {...settings} className='react-slick'>
                    <div className="image-container">
                        <img src={images.image6}/>
                    </div>
                    <div className="image-container">
                        <img src={images.image7}  />
                    </div>
                    <div className="image-container">
                        <img src={images.image8}  />
                    </div>
                   
                           

                </Slick>
            </div>
        )    
        

  }
  
}

export default Slider;


// WEBPACK FOOTER //
// ./src/components/_common/Slider/index.js